import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getMainCategory,
  updateMainCategory,
} from "../../services/category.service";
import { useSelector } from "react-redux";

export default function MainCategoryUpdate() {
  const [imagePreview, setImagePreview] = useState(null);
  const [isLoading2, setIsLoading2] = useState(false);
  const { token } = useSelector((state) => state?.auth);
  const [uploadImage, setUploadImage] = useState(null);
  const navigate = useNavigate();
  const [mainCategory, setMainCategory] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const categoryId = params.get("id");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    setError,
    clearErrors,
  } = useForm();

  const fetchMainCategory = async () => {
    try {
      const res = await getMainCategory(token, categoryId);

      if (res && res.status >= 200 && res.status < 300) {
        setMainCategory(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch category details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching main category:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the category. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (categoryId) {
      fetchMainCategory();
    }
  }, [categoryId]);

  useEffect(() => {
    if (mainCategory) {
      setValue("categoryName", mainCategory?.category_name);
      setValue("description", mainCategory?.description);
      setImagePreview(mainCategory?.image);
    }
  }, [mainCategory]);

  const onSubmit = async (item) => {
    setIsLoading2(true);

    console.log(item);

    const data = {
      category_name: item.categoryName,
      image: uploadImage,
      description: item.description,
    };

    try {
      const res = await updateMainCategory(token, data, categoryId);

      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `${item.categoryName} Category has been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
            navigate("/main-categories");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.message || "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating main category:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };

   const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (
        ["image/jpeg", "image/png", "image/jpg", "image/webp"].includes(
          file.type
        )
      ) {
        if (file.size < 1 * 1024 * 1024) {
          setImagePreview(URL.createObjectURL(file));
          setUploadImage(file);
          clearErrors("image");
        } else {
          setError("image", {
            type: "manual",
            message: "Image size must be less than 1MB.",
          });
          setUploadImage(null);
          setValue("image", null);
        }
      } else {
        setError("image", {
          type: "manual",
          message: "Only JPEG, PNG, JPG, or WEBP files are allowed.",
        });
        setUploadImage(null);
        setValue("image", null);
      }
    }
  };
  
  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Main Category</h4>
                <Link to="/main-categories">
                  <img
                    src="/assets/images/kidskart/icon/back-button.png"
                    alt="Back"
                  />
                </Link>
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Category Name */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Category Name</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter main category name"
                          {...register("categoryName", {
                            required: "Main category name is required",
                          })}
                        />
                        {errors.categoryName && (
                          <p className="error">{errors.categoryName.message}</p>
                        )}
                      </div>

                      {/* Image */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Image</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="file"
                          className="form-control"
                          {...register("image")}
                          onChange={handleImageChange}
                        />
                        {errors.image && (
                          <p className="error">{errors.image.message}</p>
                        )}
                      </div>
                      <div className="mb-4 col-md-6"></div>
                      <div className="mb-4 col-md-6">
                        {imagePreview && (
                          <img
                            src={imagePreview}
                            alt="Preview"
                            className="img-thumbnail mt-2"
                            style={{ width: "100px" }}
                          />
                        )}
                      </div>

                      {/* Description */}
                      <div className="mb-4 col-md-12">
                        <label className="form-label">Description</label>
                        <textarea
                          rows="3"
                          className="form-control"
                          placeholder="Enter description"
                          {...register("description")}
                        ></textarea>
                        {errors.description && (
                          <p className="error">{errors.description.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE MAIN CATEGORY
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING MAIN CATEGORY
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
